import React, { useEffect } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import LandingHeader from './common/LandingHeader';
import LandingFooter from './common/LandingFooter';
import './LandingPage.css';

const PrivacyPolicy = () => {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="landing-page">
      <LandingHeader />

      <section className="legal-section">
        <div className="landing-container">
          <div className="legal-content">
            <h1>{t('legal.privacyPolicyTitle')}</h1>
            <p className="legal-last-updated">{t('legal.lastUpdated')}: January 2025</p>

            <h2>1. {t('legal.privacy.section1Title')}</h2>
            <p>{t('legal.privacy.section1Content')}</p>

            <h2>2. {t('legal.privacy.section2Title')}</h2>
            <p>{t('legal.privacy.section2Content')}</p>
            <ul>
              <li>{t('legal.privacy.section2Item1')}</li>
              <li>{t('legal.privacy.section2Item2')}</li>
              <li>{t('legal.privacy.section2Item3')}</li>
              <li>{t('legal.privacy.section2Item4')}</li>
            </ul>

            <h2>3. {t('legal.privacy.section3Title')}</h2>
            <p>{t('legal.privacy.section3Content')}</p>
            <ul>
              <li>{t('legal.privacy.section3Item1')}</li>
              <li>{t('legal.privacy.section3Item2')}</li>
              <li>{t('legal.privacy.section3Item3')}</li>
              <li>{t('legal.privacy.section3Item4')}</li>
            </ul>

            <h2>4. {t('legal.privacy.section4Title')}</h2>
            <p>{t('legal.privacy.section4Content')}</p>

            <h2>5. {t('legal.privacy.section5Title')}</h2>
            <p>{t('legal.privacy.section5Content')}</p>

            <h2>6. {t('legal.privacy.section6Title')}</h2>
            <p>{t('legal.privacy.section6Content')}</p>

            <h2>7. {t('legal.privacy.section7Title')}</h2>
            <p>{t('legal.privacy.section7Content')}</p>

            <h2>8. {t('legal.privacy.section8Title')}</h2>
            <p>{t('legal.privacy.section8Content')}</p>
          </div>
        </div>
      </section>

      <LandingFooter />
    </div>
  );
};

export default PrivacyPolicy;

